import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/dashboard',
      //redirect: {name: 'students'},
      component: () =>
        import(
          /* webpackChunkName: "dashboard" */ './components/Dashboard.vue'
        ),
      name: 'dashboard',
      children: [
        {
          path: '/dashboard/templates',
          component: () =>
            import(/* webpackChunkName: "templates" */ './components/Templates.vue'),
          name: 'templates'
        },
        {
          path: '/dashboard/students',
          component: () =>
            import(/* webpackChunkName: "students" */ './components/Users.vue'),
          name: 'students',
          props: { userType: 'student' },
        },
        {
          path: '/dashboard/assessments',
          component: () =>
            import(
              /* webpackChunkName: "assessments" */ './components/Assessments.vue'
            ),
          name: 'assessments',
        },
        {
          path: '/dashboard/faculty',
          component: () =>
            import(/* webpackChunkName: "faculty" */ './components/Users.vue'),
          name: 'faculty',
          props: { userType: 'faculty' },
        },
        {
          path: '/dashboard/admin',
          component: () =>
            import(/* webpackChunkName: "faculty" */ './components/Users.vue'),
          name: 'admin',
          props: { userType: 'admin' },
        },
        {
          path: '/dashboard/group-leaders',
          component: () =>
            import(/* webpackChunkName: "faculty" */ './components/Users.vue'),
          name: 'group_leader',
          props: { userType: 'group_leader' },
        },
        {
          path: '/dashboard/groups',
          component: () =>
            import(/* webpackChunkName: "groups" */ './components/Groups.vue'),
          name: 'groups',
        },
        {
          path: '/dashboard/settings',
          component: () =>
            import(
              /* webpackChunkName: "settings" */ './components/Settings.vue'
            ),
          name: 'settings',
        },
      ],
    },
    {
      path: '/assessment/:id',
      component: () =>
        import(
          /* webpackChunkName: "assessment" */ './components/Assessment.vue'
        ),
      name: 'assessment',
    },
    {
      path: '/assessment/:id/:user',
      component: () =>
        import(
          /* webpackChunkName: "assessment_user" */ './components/Assessment.vue'
        ),
      name: 'assessment_user',
    },
    {
      path: '/monthly/grades',
      component: () =>
        import(
          /* webpackChunkName: "monthly_grades" */ './components/MonthlyGrades.vue'
        ),
      name: 'monthly_grades',
    },
    {
      path: '/',
      name: 'home',
      redirect: { name: 'dashboard' },
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "login" */ './views/Login.vue'),
    },
    {
      path: '/dashboard/landing',
      component: () =>
        import(/* webpackChunkName: "students" */ './views/LoginLanding.vue'),
      name: 'landing',
      props: { userType: 'faculty' },
    },
    {
      path: '/system/login',
      name: 'system-login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "login-old" */ './views/LoginOld.vue'),
    },
  ],
});
